import { useQuery } from "@apollo/client";
import { GET_SUBSCRIPTION_BILLING_CURRENCIES } from "../graphql/operations/subscription";

export type BillingCurrencyCode = "usd" | "inr";

const DEFAULT_CURRENCIES: BillingCurrencyCode[] = ["usd"];

export function buildEmptyPlanPrices(currencies: string[]) {
    return currencies.map((currency) => ({ currency, monthlyPrice: 0, yearlyPrice: 0 }));
}

export function buildEmptySetupFeePrices(currencies: string[]) {
    return currencies.map((currency) => ({ currency, amount: 0, chatAmount: 0, callAmount: 0 }));
}

export function useSubscriptionBillingCurrencies() {
    const { data, loading, error } = useQuery(GET_SUBSCRIPTION_BILLING_CURRENCIES, {
        fetchPolicy: "cache-first",
    });

    const raw = data?.subscriptionBillingCurrencies;
    const currencies: BillingCurrencyCode[] = Array.isArray(raw)
        ? raw
              .map((code: string) => String(code || "").trim().toLowerCase())
              .filter((code: string): code is BillingCurrencyCode => code === "usd" || code === "inr")
        : [];

    return {
        currencies: currencies.length > 0 ? currencies : DEFAULT_CURRENCIES,
        loading,
        error,
        isSingleCurrency: (currencies.length > 0 ? currencies : DEFAULT_CURRENCIES).length <= 1,
    };
}

export default useSubscriptionBillingCurrencies;
